import React, { useEffect } from 'react';

const StakingModalShell = ({ title, onClose, children, footer }) => {
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div
      className="staking-modal-overlay"
      role="presentation"
      onClick={onClose}
    >
      <div
        className="staking-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="staking-modal-title"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="staking-modal-header">
          {typeof title === 'string' ? (
            <h2 id="staking-modal-title" className="staking-modal-title">
              {title}
            </h2>
          ) : (
            <div id="staking-modal-title" className="staking-modal-title-node">
              {title}
            </div>
          )}
          <button
            type="button"
            className="staking-modal-close"
            onClick={onClose}
            aria-label="Close"
          >
            ×
          </button>
        </div>
        <div className="staking-modal-body">{children}</div>
        {footer ? <div className="staking-modal-footer">{footer}</div> : null}
      </div>
    </div>
  );
};

export default StakingModalShell;
